/* Parwin price promise: tap the announcement bar message to see a short note on our pricing vs Amazon. */
(function () {
  if (window.__ppPricePromise) return; window.__ppPricePromise = true;

  var CSS = ''
  + '.announcement-bar a[href="#price-promise"]{cursor:pointer;text-decoration:underline;text-underline-offset:3px;text-decoration-thickness:1px}'
  + '.pprom{position:fixed;inset:0;z-index:99998;display:none;align-items:center;justify-content:center;padding:18px;background:rgba(0,0,0,.5)}'
  + '.pprom.is-open{display:flex}'
  + '.pprom__card{background:#fff;border-radius:14px;max-width:440px;width:100%;padding:26px 24px 22px;position:relative;box-shadow:0 12px 40px rgba(0,0,0,.25);animation:pprom-in .16s ease}'
  + '@keyframes pprom-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}'
  + '.pprom__close{position:absolute;top:10px;right:12px;border:0;background:none;font-size:26px;line-height:1;color:#8a8a8a;cursor:pointer;padding:2px 6px}'
  + '.pprom__close:hover{color:#1a1a1a}'
  + '.pprom__title{font-size:1.2rem;font-weight:700;color:#1a1a1a;margin:0 26px 12px 0}'
  + '.pprom__body{font-size:.95rem;line-height:1.6;color:#4a4a4a;margin:0 0 12px}'
  + '.pprom__link{display:inline-flex;align-items:center;gap:6px;font-weight:700;color:#d81e1e;text-decoration:none;font-size:.95rem;margin-top:4px}'
  + '.pprom__link:hover{text-decoration:underline}';
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

  var pop, lastFocus;
  function build() {
    if (pop) return;
    pop = document.createElement('div'); pop.className = 'pprom';
    pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-modal', 'true'); pop.setAttribute('aria-labelledby', 'pprom-title');
    pop.innerHTML = '<div class="pprom__card"><button class="pprom__close" aria-label="Close">&times;</button>'
      + '<h3 class="pprom__title" id="pprom-title">Our price promise</h3>'
      + '<p class="pprom__body">We always aim to keep our prices lower than Amazon, so buying direct from us is the best way to get your Parwin tools.</p>'
      + '<p class="pprom__body">Spotted a price that’s higher with us? Just let us know and we’ll look into it straight away. We keep our prices regularly updated.</p>'
      + '<a class="pprom__link" href="/pages/contact">Get in touch &rarr;</a></div>';
    document.body.appendChild(pop);
    pop.querySelector('.pprom__close').addEventListener('click', close);
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
  }
  function open() {
    build(); lastFocus = document.activeElement;
    pop.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
    pop.querySelector('.pprom__close').focus();
  }
  function close() {
    if (!pop) return;
    pop.classList.remove('is-open'); document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href="#price-promise"]');
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    open();
  });
})();
